import { render, staticRenderFns } from "./ERlebt.vue?vue&type=template&id=01ebec92"
import script from "./ERlebt.vue?vue&type=script&lang=js"
export * from "./ERlebt.vue?vue&type=script&lang=js"
import style0 from "./ERlebt.vue?vue&type=style&index=0&id=01ebec92&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports